
import React, { Component } from 'react';
import services from '../../../../services';
import $ from 'jquery'
import ReactDOM from "react-dom";
import TlkTable from '../../../../components/tlelrik/table/tlkTable';
import RightPopModalForm from '../../../../components/common/RightPopModalForm';
import { Grid, GridColumn as Column, GridToolbar } from "@progress/kendo-react-grid";
import ParcelVirsion from '../../../../components/Parcel-Right-panel/ParcelVirsion';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { insertItem, getItems2, updateItem, deleteItem, deleteAll } from "./services2";
import { MyCommandCell } from "./MyCommandCell2"
import { NumericCell } from '../NumericText';
import { FormatMoney } from '../FormatMoney';
import DropDownCellTipoVasilha from '../myDropDownCellTipoVasilha';
import DropDownCellNVasilha from '../myDropDownCellNVasilha';
import DropDownCellCapacidades from '../myDropDownCellCapacidades';
import DropDownCellProduto from '../myDropDownCellProduto';
import SelectCellEtiquetas from '../mySelectCellEtiquetas';
import SelectCellSelos from '../mySelectCellSelos';
import DropDownCellCorrelativa from '../myDropDownCellCorrelativa';
import DropDownCellCorrelativaProduto from '../myDropDownCellCorrelativaProduto';
import SelectCellSelosGarantia from '../mySelectCellSelosGarantia';
import Swal from 'sweetalert2';
import SelectCellEtiquetasSelagem from '../mySelectCellEtiquetasSelagem';
import SelectCellSelosSelagem from '../mySelectCellSelosSelagem';
import DropDownCellRegisto from '../myDropDownCellRegisto';
import handleChange from "../myDropDownCellRegisto"

var arrayDataOnEdit = []
var arrayData = []
var ThisSetState = null;

var ValueTipoVasilhaSelected = null;

var DropDownDisableValue = true;

var idDropDownSelected = null;
var DropDownDisableArray = [];
var idDropDownDisableArray = 0;
var ThisDropDownDisable = null;

var ThisSetStateCreated = false;
const GridElement = null;
var camposExtra = []

const queryString = require('query-string');
var moment = require('moment')
const dateFormat = "DD-MM-YYYY";
const fullDateFormat = "DD-MM-YYYY HH:mm:ss";
let listdefaultRequest = { Filters: null, "SortBy": "id", "IsSortTypeDESC": true, "IsPagination": true, "Page": 1, "PageSize": 100 }
let today = new Date();
let current_date = moment(today).format(dateFormat);
today.setDate(today.getDate() - 7);
let LastWeek = moment(today).format(dateFormat);

today = new Date();
today.setDate(today.getDate() - 14);
let Last2Week = moment(LastWeek).format(dateFormat);

today = new Date();
today.setMonth(today.getMonth() - 1);
let Pastmonthdate = moment(today).format(dateFormat);
const editField = "inEdit"; 



let tablesjson = {
    "LinhasFatura": {
        columnkeyMap: {
            "Registo": "Registo/Produto (todos)",
            "cor": "Cor",
            "VolumeAferido": "Colume aferido",
            "SeloSeguranca": "Selos de Segurança",
            "QuantidadeIVDP": "Nº Garrafas",
            "CapacidadeIVDP": "Capacidade",
            "EtiquetasSeguraca": "Etiquetas de segurança",
            "QuantidadeAE": "Nº Garrafas",
            "CapacidadeAE": "Capacidade",
            "Etiquetas": "Etiquetas de segurança"
        },
        // actionbuttons: { 
        //     module: "Receita",  
        // },
        //listApilink: "/Receita/GetFaturaLinhas",
        requestMethod: "get",
        notAction: false,
        //totalPageHeading : "Lista de pedidos para iniciar avaliação ",
        Filters: {
            //"IdFatura" : 0
        },
    },
}

class DropDownCellFiscalizacao2 extends React.Component {

    localizedData = [
      { text: 'Escala', value: 1 },
      { text: 'Estimativa', value: 2 },
      { text: 'Cálculo', value: 3 }
    ];
  
    handleChange = (e) => {
      this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e != null ? e.syntheticEvent : null,
        value: e != null ? e.target != null ? e.target.value : null : null
      });
    }
    
    static disablEnableDroDown = (disable) => {
        DropDownDisableValue = disable;
        ThisDropDownDisable.handleChange();

    }

    render() {
        ThisDropDownDisable = this;
        
        const dataValue = this.props.dataItem[this.props.field];
        
        if (!this.props.dataItem.inEdit) {
            return (
            <td>
                {(dataValue === null || dataValue === undefined) ? '' : this.props.dataItem[this.props.field].text}
            </td>
            );
        }

        return (
            <td>

                <DropDownList
                    popupSettings={{
                        width: 'max-content',
                    }}
                    disabled={DropDownDisableValue}
                    onChange={this.handleChange}
                    value={this.localizedData.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
                    data={this.localizedData}
                    textField="text"
                />

            </td>
        );
        
    }
}

class DropDownCellMotivoDispensa2 extends React.Component {

    localizedData = [
      { text: 'Início imediato do despejo', value: 1 },
      { text: 'Nº reduzido de garrafas devolvidas', value: 2 },
      { text: 'Colheita de amostras há menos de 6 meses', value: 3 }
    ];
  
    handleChange = (e) => {
      this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e != null ? e.syntheticEvent : null,
        value: e != null ? e.target != null ? e.target.value : null : null
      });
    }

    render() {
        ThisDropDownDisable = this;
        
        const dataValue = this.props.dataItem[this.props.field];
        
        if (!this.props.dataItem.inEdit) {
            return (
            <td>
                {(dataValue === null || dataValue === undefined) ? '' : this.props.dataItem[this.props.field].text}
            </td>
            );
        }

        return (
            <td>

                <DropDownList
                    popupSettings={{
                        width: 'max-content',
                    }}
                    onChange={this.handleChange}
                    value={this.localizedData.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
                    data={this.localizedData}
                    textField="text"
                />

            </td>
        );
        
    }
}

class ClassGrid2 extends Component {
    /* Primeiro passo na acomodação da classe */
    

    constructor(props) {
        super(props);
        this.state = {
            linkData: tablesjson[this.props.tableName],
            telkikTable: null,
            popUpForm: null,
            tlkState: null,
            findnonDocumentedRow: 0,
            error : null,
            filtroEntidade: null,
            artigo: [],
            Auto:null,
            Columns:[],
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {

        console.log(this.props.columnList);

        
        ThisSetState = this;

       // this.defaultState();

        (async () => {
            this.setState({
                data: await getItems2(),
                Columns: this.props.columnList
            });
    
            
        })();
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (preProp) => {
        if (preProp.date !== this.props.date || preProp.tableName !== this.props.tableName) {
            console.log("update",this.props,preProp)
            //this.defaultState();
        }
    }


    /* Para obter filtros para a API */
    getAllFilter = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        Request.Filters = { ...Request.Filters, ...this.props.applyedfilter }
        console.log("Request" ,Request)
       
        this.setState({
            filtroEntidade: Request.Filters.entityIdFilter,
        });
        console.log("STATE" , Request.Filters.entityIdFilter)
       
        console.log("Fileter", Request.Filters);
        if (Request.Filters.entity_id === undefined) {
            Request.Filters.entity_id = null
        }
        Request.Filters.local = null // window.localStorage.getItem('Local');
        if (this.props.tableName === "Faturas" && Request.Filters.entity_id > 0) {
            Request.Filters.is_paid = null;
        }

        // Request = { ...Request.Filters };
        var SecundaryRequest = {"IdFatura": 0}
        console.log("CENASSSSSSSSSS" ,SecundaryRequest)
        return SecundaryRequest ;
    }


    /*  Para excluir uma linha da base de dados no servidor */

    handleDelete = async (id) => {
        let link = this.state.linkData.deleteAPILink;
        let res = await services.apiCall.requestApi(link + "/" + id, {}, 'post')
        if (res) {
           // this.defaultState();
        }
    }

    /* Carregar estado de página padrão  */

    defaultState = () => {
        let linkData = { ...tablesjson }
        linkData = tablesjson.LinhasFatura;
        this.setState({
            linkData: linkData,
            findnonDocumentedRow: 0,
            tlkState: {
                take: 100,
                skip: 0,
                group: [],
                exporting: false,
            }
        }, () => this.getListData())
    }

    /*Para obter dados para a tabela usando apis */

    getListData = async () => {
        try {
            if (!this.state.linkData) return
            let Request = this.getAllFilter();
            if (this.state.linkData.singleEntity) {
                this.setState({
                    totalcount: 0,
                    telkikTable: null,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                })
            }
            if (this.state.linkData.singleEntity && (!Request.Filters.entity_id && !Request.Filters.invoice_id)) return
            let method = this.state.linkData.requestMethod;
            let link = this.state.linkData.listApilink;
            let columnkeyMap = this.state.linkData.columnkeyMap;
            console.log("OUTRO OBJETO" , Request)
            let res = await services.apiCall.requestApi(link, Request, method);
            var invoicecode = [];
            let findnonDocumentedRow = 0;
         
            if (res && res.length > 0) {
                res.map((_row, index) => {
                    if (_row.invoiceHistory && _row.invoiceHistory.length > 0) {
                        
                        _row.invoiceHistory.map((_r, i) => {
                            invoicecode = [];
                            if (_r.file_Link && _r.invoiceType) {
                                invoicecode = _r.invoiceType.split("-");
                                if (invoicecode[0] === "IVF" || invoicecode[0] === "IVP" || invoicecode[0] === "API") {
                                    _row.document_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                                } else {
                                    _row.invoice_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                                }
                            } else {
                                findnonDocumentedRow = findnonDocumentedRow + 1;
                            }
                        })
                    } else {
                        findnonDocumentedRow = findnonDocumentedRow + 1;
                        console.log("AGORA" , _row)
                    }
                    Object.keys(columnkeyMap).map(function (key) {
                        if (key === "n doc") {
                            _row[columnkeyMap[key]] = _row.no
                        } else if (key === "Entidade") {
                            _row[columnkeyMap[key]] = _row.busEntidade.nome

                        }else if (key === "dataCriado") {
                            _row[columnkeyMap[key]] = _row.dataCriado
                                ? moment(_row.dataCriado).format(
                                    fullDateFormat
                                  )
                                : "nd";
                        }else if (key === "dataPagamento") {
                            _row[columnkeyMap[key]] = _row.dataPagamento
                                ? moment(_row.dataPagamento).format(
                                    fullDateFormat
                                  )
                                : "nd";
                        } else if (key === "entityObject") {
                            _row[columnkeyMap[key]] = _row.entity_id ? _row.entityObject.nome : ""
                        } else if (key === "flag") {
                            _row[columnkeyMap[key]] = _row['flag'];
                        } else if (key === "Invoice_date" || key === "issue_date_time") {
                            _row[columnkeyMap[key]] = moment(_row['issue_date_time']).format(dateFormat);
                        } else if (key === "pag_limit") {
                            _row[columnkeyMap[key]] = _row['deadline_date'] ? moment(_row['deadline_date']).format(dateFormat) : moment(_row['issue_date_time']).format(dateFormat);
                        } else if (key === "is_doc_generated") {
                            _row[columnkeyMap[key]] = parseInt(_row['is_doc_generated']) === 1 ? "Sim" : "Não";
                        } else if (key === "Interest_to_date") {
                            _row[columnkeyMap[key]] = services.money.format(_row.service_tax);
                        } else if (key === "Valor c/ IVA") {
                            _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                        } else if (key === "valor_cativo") {
                            _row[columnkeyMap[key]] = services.money.format(_row.valor_cativo);
                        } else if (key === "Valor IVA") {
                            _row[columnkeyMap[key]] = services.money.format(_row.iva);
                        } else if (key === "add_Amonut_text") {
                            _row[columnkeyMap[key]] = _row.allTransaction && _row.allTransaction[0] ? _row.allTransaction[0].comment : "";
                        } else if (key === "for_invoice_id") {
                            _row[columnkeyMap[key]] = _row.for_invoice_id ? "Pagamento da Fatura" : "Pagamento Antecipado";
                        } else if (key === "is_paid") {
                            _row[columnkeyMap[key]] = _row[key] === 0 ? "Pendente" : "Não Pendente";
                        } else if (key === "Amount_paid") {
                            _row[columnkeyMap[key]] = services.money.format(_row['amount_paid']);
                        } else if (key === "outgoingAmount" && _row['document_type'] === 'Invoice') {
                            _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                        } else if (key === "incomingAmount" && _row['document_type'] === 'Credit') {
                            _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                        } else if (key === "valor") {
                            _row["valor"] = _row.trans_type === "CR" ? _row.total_cr : "-" + _row.total_dr;
                            _row[columnkeyMap[key]] = services.money.format(_row["valor"]);
                        } else if (key === "nifap") {
                            _row[columnkeyMap[key]] = _row.busEntidadeDetail.nifap
                        } else if (key === "nome") {
                            if (_row.busEntidade) {
                                _row[columnkeyMap[key]] = _row.busEntidade[key]
                            }
                            else {
                                _row[columnkeyMap[key]] = _row.busEntidadeDetail.nome
                            }
                        } else if (key === "trans_date") {
                            _row[columnkeyMap[key]] = moment(_row['trans_date']).format(dateFormat);
                        } else if (key === "current_balance") {
                            _row[columnkeyMap[key]] = services.money.format(_row["current_balance"]);
                        } else if (key === "total_amount") {
                            _row[columnkeyMap[key]] = services.money.format(_row["total_amount"]);
                        } else if (key === "local") {
                            _row[columnkeyMap[key]] = _row["key"] || '';
                        } else if (key === "amount_paid") {
                            _row[columnkeyMap[key]] = services.money.format(_row[key]);
                        } else if (key === "trans_amount") {
                            _row[columnkeyMap[key]] = services.money.format(_row["trans_amount"]);
                        } else if (key === "balance") {
                            _row[columnkeyMap[key]] = services.money.format(_row["balance"]);
                        }

                        // else if(key==="document_type" && _row.document_type==="Invoice") {
                        //     _row.document_type = "Movements"
                        // }else if(key==="document_type" && _row.document_type==="Credit") {
                        //     _row.document_type = "Crédito"
                        // }
                        else
                            _row[columnkeyMap[key]] = _row[key]
                    })
                    if (_row.document_type === "Invoice") {
                        _row.document_type = "Movements"
                    } else if (_row.document_type === "Credit") {
                        _row.document_type = "Crédito"
                    }
                });
                console.log("Akash","1",res);
                this.setState({
                    data: res,
                    filterData: res,
                    totalcount: res.length,
                    findnonDocumentedRow
                }, () =>{
                    console.log("Akash","2");
                    this.createTabel()
                });
            }else{
                this.setState({
                    data: res,
                    filterData: res,
                    totalcount:0
                },()=>{
                    this.createTabel()
                })
            }
        } catch (error) {
            this.setState({error})
        }
    }

    /* Para carregar o componente da tabela e definir todas as colunas  */

    createTabel = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        Request.Filters = { ...Request.Filters, ...this.props.applyedfilter }
        console.log("Request" ,Request)
        
        console.log("STATE" , Request.Filters.entityIdFilter)
        console.log("Akash","3" , Request.Filters.entityIdFilter);
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = {...this.state.linkData.columnkeyMap}
            if (this.state.findnonDocumentedRow === 0) {
                delete columnkeyMap["Check"]
            }
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
            });
            let actionbuttons = this.state.linkData.actionbuttons;
            console.log("columnlist",columnlist);
            console.log("filterData",this.state.filterData);
            
            let telkikTable = <TlkTable
                date={new Date()}
                generateDocument={this.state.findnonDocumentedRow === 0 ? null : this.state.linkData.generateDocument}
                noDownloadButton={this.state.linkData.noDownloadButton}
                DocumentGERFIP={this.state.linkData.DocumentGERFIP}
                actionColumnName={this.state.linkData.actionColumnName}
                groupfield={this.state.linkData.groupfield}
                modulename={this.state.linkData.modulename || "CriarFatura"}
                notAction={this.state.linkData.notAction}
                tlkState={this.state.tlkState}
                notGroup={true}
                deleteFunc={(id) => this.props.handleDelete(id)}
                tableFilters={(filter) => this.tableFilters(filter)}
                list={this.state.filterData}
                actionbuttons={actionbuttons}
                columnlist={columnlist}
                ActionPerform={(action, id) => this.ActionPerform(action, id)} />
            this.setState({
                telkikTable: telkikTable
            })
        }
    }

    /* Obter filtros aplicados na tabela para atualização dinâmica */
    tableFilters = (tlfilter) => {
        console.log("tlfilter",tlfilter);
        try{
            if(JSON.stringify(tlfilter) !== JSON.stringify(this.state.tlkState)){
                let customfilters = this.getAllFilter();
                let columnkeyMap = this.state.linkData.columnkeyMap;
                let tlkState = { ...tlfilter };
                let data = this.makeTlkFilters(tlfilter, columnkeyMap, customfilters);
                let linkData = { ...this.state.linkData };
            
                // linkData.Filters = data.Filters
                this.setState({
                    tlkState,
                    linkData
                }, () => this.getListData());
            }
        }catch(error){
            this.setState({error : error})
        }
        // return data;
    }

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let tlkState
        let inFilters = {};
        let columnkeyMaprev = {};
        // console.log("-----------pppppppppp",columnkeyMap)
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (tlkfilter.filter && tlkfilter.filter.filters && tlkfilter.filter.filters.length > 0) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        _srow.value=_srow.value ?_srow.value : ""
                        checkamount =  _srow.value.split(" ")
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value) ? Number(_srow.value) : _srow.value;
                        tkkeyvalues.push(_srow.value)
                    })
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            })
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip ? (tlkfilter.skip / tlkfilter.take + 1) : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC = (tlkfilter.sort[0].dir === "asc") ? false : true;
        }
        // data.inFilters = inFilters;
        return data;
    }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        console.log("action perform")
        if (this.props.ActionPerform) {
            this.props.ActionPerform(action, row)
        } else {
            let popUpForm = null;
        }
    }

    static removeAllRows(){
        if(ThisSetState){
            ThisSetState.refreshDS(true);
        }
    };

    /*  Para renderizar o conteúdo html da página   */
    static CommandCell = props => <MyCommandCell {...props} edit={ThisSetState.enterEdit} remove={ThisSetState.remove} add={ThisSetState.add} discard={ThisSetState.discard} update={ThisSetState.update} cancel={ThisSetState.cancel} editField={editField} />; // modify the data in the store, db etc

    remove = dataItem => {
      const data = deleteItem(dataItem);
      this.setState({
        data : data
      });
    };

    add = dataItem => {
        var arrayElementos =  []  
        arrayElementos.length = 0
        var inputsGrid = $(".k-grid-table tbody td input#numberboxcell");
        var selectGrid = $("span.k-input");
        for (let index = 0; index < inputsGrid.length; index++) {
            var elementos = inputsGrid[index].value;
            var elementoInput = inputsGrid[index];
            if($(elementoInput).prop("disabled") == false){
                if(elementos == ""){
                    arrayElementos.push(elementos)
                }
            }
        }
        for (let i = 0; i < selectGrid.length; i++) {
            var elementos = selectGrid[i].innerHTML
            if(elementos == ""){
                arrayElementos.push(elementos)
            }
        }
        var multipleselect = $(".k-grid-table tbody td .ant-select-show-search")
        for (let index = 0; index < multipleselect.length; index++) {
            var elementos = multipleselect[index].children
            if(elementos.length == 2 ){
                
            }else{
                arrayElementos.push("")
            }
            
        }
        
        // if(arrayElementos.length > 0){
        //     Swal.fire({
        //         title: 'Têm de preencher todos os campos na grid',
        //         icon: 'error',
        //         confirmButtonText: 'Ok'
        //     })
        // }else{
            dataItem.inEdit = true;
            const data = insertItem(dataItem);
            arrayDataOnEdit = [];
            arrayDataOnEdit.push(dataItem);
            this.setState({
                data: data
            });
        //}
        
    }

    update = dataItem => {
      dataItem.inEdit = false;
      const data = updateItem(dataItem);
      this.setState({
        data
      });

     
    }; // Local state operations
  
    discard = () => {
      const data = [...this.state.data];
      data.splice(0, 1);
      this.setState({
        data
      });
      arrayData.splice(0,1);
    };

    cancel = dataItem => {
        this.setState({data:  this.state.data.map(item => item === dataItem ? { ...item,inEdit: false } : item)}); 
    };

    enterEdit = dataItem => {
        console.log(this.state.data)
        if(this.state.data.length > 0){
            this.setState({
                data: this.state.data.map(item => item === dataItem ? { ...item,inEdit: true , NewItem :false} : item)
              });
        }else{
            this.setState({
                data: arrayData.map(item => item.ProductID === dataItem.ProductID ? { ...item,inEdit: true ,NewItem :false} : item)
              });
        }
    };
   
    itemChange = event => {
        
        if(event.field == "Tipo_Vasilha"){
            DropDownCellNVasilha.ChangeValueById(event.value.value);

        }

        if(event.field == "Reg_Depos"){

            DropDownCellFiscalizacao2.disablEnableDroDown(!event.value);
    
        }
        if(event.field == "Produto_NC_GA_IG_engarrafado"){
            DropDownCellCorrelativaProduto.ChangeValueById(event.value)
        }

        if(event.field == "Registo_DO"){

            (async () => {
                const data = {"numeroRegisto" : event.value.text , "idEntidade": parseInt($("#instal_vinica_auto :selected").val().split("!")[1])}
                const ContaCorrenteAgrupada = await services.apiCall.requestApi(
                  "/Fiscalizacao/GetContaCorrenteAgrupada",
                  data,
                  "get"
                );
        
                if(ContaCorrenteAgrupada){
                  
                    var prodAcabado = 0;
                    var indGranel = 0;
                    var indEngarrafado = 0;

                    for (let index = 0; index < ContaCorrenteAgrupada.length; index++) {
                        if(ContaCorrenteAgrupada[index].produtoAcabado != null && ContaCorrenteAgrupada[index].produtoAcabado != ""){
                            prodAcabado = parseFloat(ContaCorrenteAgrupada[index].produtoAcabado)
                        }
                        if(ContaCorrenteAgrupada[index].indisponivelGranel != null && ContaCorrenteAgrupada[index].indisponivelGranel != ""){
                            indGranel = parseFloat(ContaCorrenteAgrupada[index].indisponivelGranel)
                        }
                        if(ContaCorrenteAgrupada[index].indisponivelEngarrafado != null && ContaCorrenteAgrupada[index].indisponivelEngarrafado != ""){
                            indEngarrafado = parseFloat(ContaCorrenteAgrupada[index].indisponivelEngarrafado)
                        }
                    }
                    var a = this;

                    this.state.data[this.state.data.findIndex(c=> c.Registo_DO.text == event.value.text)].IndispGranelQBD = indGranel;
                    this.state.data[this.state.data.findIndex(c=> c.Registo_DO.text == event.value.text)].IndispEngaQBD = indEngarrafado;
                    this.state.data[this.state.data.findIndex(c=> c.Registo_DO.text == event.value.text)].ProdutoAcabadoQBD = prodAcabado;
                    this.state.data[this.state.data.findIndex(c=> c.Registo_DO.text == event.value.text)].TotalQBD = indGranel + indEngarrafado + prodAcabado;                   
                    
                    $('.IndispGranelQBD').text(indGranel.toString())
                    $('.IndispGranelQBD').val(indGranel.toString())
                    
                    $('.IndispEngaQBD').text(indEngarrafado.toString())
                    $('.IndispEngaQBD').val(indEngarrafado.toString())

                    $('.ProdutoAcabadoQBD').text(prodAcabado.toString())
                    $('.ProdutoAcabadoQBD').val(prodAcabado.toString())

                    $('.TotalQBD').text((indGranel + indEngarrafado + prodAcabado).toString())
                    $('.TotalQBD').val((indGranel + indEngarrafado + prodAcabado).toString())

                    $('.IndispGranelQA').text('')
                    $('.IndispGranelQA').val('')
                    
                    $('.IndispEngaQA').text('')
                    $('.IndispEngaQA').val('')

                    $('.ProdutoAcabadoQA').text('')
                    $('.ProdutoAcabadoQA').val('')

                    $('.VendasQA').text('')
                    $('.VendasQA').val('')

                    $('.TotalQA').text('')
                    $('.TotalQA').val('')
                    
                    // $('.IndispGranelQA').trigger('change')
                    // $('.IndispEngaQA').trigger('change')
                    // $('.ProdutoAcabadoQA').trigger('change')
                    // $('.VendasQA').trigger('change')
                   
                    $('.IndispGranelQA').prop("disabled", false);
                    $('.IndispEngaQA').prop("disabled", false);
                    $('.ProdutoAcabadoQA').prop("disabled", false);
                    $('.VendasQA').prop("disabled", false);


                };       
            })();


            

        }
        
        if(event.field == "IndispGranelQA" && event.dataItem.Registo_DO != null){

            this.state.data[this.state.data.findIndex(c=> c.Registo_DO.text == event.dataItem.Registo_DO.text)].IndispGranelQT = event.value - $('.IndispGranelQBD').val();
            
            var result = event.value - $('.IndispGranelQBD').val();

            $('.IndispGranelQT').text(result.toString())
            $('.IndispGranelQT').val(result.toString())
            
            this.changeTotalQT(event.dataItem.Registo_DO.text);

            this.changeTotalQA(event.dataItem.Registo_DO.text);

        }
        if(event.field == "IndispEngaQA" && event.dataItem.Registo_DO != null){

            this.state.data[this.state.data.findIndex(c=> c.Registo_DO.text == event.dataItem.Registo_DO.text)].IndispEngaQT = event.value - $('.IndispEngaQBD').val();

            $('.IndispEngaQT').text(event.value - $('.IndispEngaQBD').val())
            $('.IndispEngaQT').val(event.value - $('.IndispEngaQBD').val())
            
            this.changeTotalQT(event.dataItem.Registo_DO.text);

            this.changeTotalQA(event.dataItem.Registo_DO.text);

        }
        if(event.field == "ProdutoAcabadoQA" && event.dataItem.Registo_DO != null){

            // this.state.data[this.state.data.findIndex(c=> c.Registo_DO.text == event.dataItem.Registo_DO.text)].ProdutoAcabadoQT = event.value - $('.ProdutoAcabadoQBD').val();

            // $('.ProdutoAcabadoQT').text(event.value - $('.ProdutoAcabadoQBD').val())
            // $('.ProdutoAcabadoQT').val(event.value - $('.ProdutoAcabadoQBD').val())

            var quantidadeProdutoAcabado = $(".ProdutoAcabadoQA").val() != undefined &&  $(".ProdutoAcabadoQA").val() != ''? parseFloat($(".ProdutoAcabadoQA").val()) : 0;
            var vendas = $(".VendasQA").val() != undefined && $(".VendasQA").val() != '' ? parseFloat($(".VendasQA").val()) : 0;
            var produtoAcabadoBD = $('.ProdutoAcabadoQBD').val() != undefined &&  $('.ProdutoAcabadoQBD').val() != '' ? parseFloat($('.ProdutoAcabadoQBD').val()) : 0;

            $('.ProdutoAcabadoQT').text(((quantidadeProdutoAcabado + vendas)-produtoAcabadoBD).toString());
            $('.ProdutoAcabadoQT').val(((quantidadeProdutoAcabado + vendas)-produtoAcabadoBD).toString());
            this.state.data[this.state.data.findIndex(c=> c.Registo_DO.text == event.dataItem.Registo_DO.text)].ProdutoAcabadoQT = ((quantidadeProdutoAcabado + vendas)-produtoAcabadoBD).toString();

            this.changeTotalQT(event.dataItem.Registo_DO.text);

            this.changeTotalQA(event.dataItem.Registo_DO.text);

        }
        if(event.field == "VendasQA" && event.dataItem.Registo_DO != null){

            var quantidadeProdutoAcabado = $(".ProdutoAcabadoQA").val() != undefined &&  $(".ProdutoAcabadoQA").val() != ''? parseFloat($(".ProdutoAcabadoQA").val()) : 0;
            var vendas = $(".VendasQA").val() != undefined && $(".VendasQA").val() != '' ? parseFloat($(".VendasQA").val()) : 0;
            var produtoAcabadoBD = $('.ProdutoAcabadoQBD').val() != undefined &&  $('.ProdutoAcabadoQBD').val() != '' ? parseFloat($('.ProdutoAcabadoQBD').val()) : 0;

            $('.ProdutoAcabadoQT').text(((quantidadeProdutoAcabado + vendas)-produtoAcabadoBD).toString());
            $('.ProdutoAcabadoQT').val(((quantidadeProdutoAcabado + vendas)-produtoAcabadoBD).toString());
            this.state.data[this.state.data.findIndex(c=> c.Registo_DO.text == event.dataItem.Registo_DO.text)].ProdutoAcabadoQT = ((quantidadeProdutoAcabado + vendas)-produtoAcabadoBD).toString();
            this.changeTotalQA(event.dataItem.Registo_DO.text);

            


        }
        if(event.field == "TotalQA" && event.dataItem.Registo_DO != null){

            // this.changeTotalQT(event.dataItem.Registo_DO.text);

            // this.changeTotalQA(event.dataItem.Registo_DO.text);

        }


        const data = this.state.data.map(item => event.dataItem != null ?  item.ProductID === event.dataItem.ProductID ? { ...item,
            [event.field || '']: event.value
        } : item : item);
        this.setState({
            data
        });

    };
    static itemChange2 = event => {
        var arrayextra = [];
        (async () => {   
            const datax = {"numeroRegisto" : event , "idEntidade": parseInt($("#instal_vinica_auto :selected").val().split("!")[1])}
            var ContaCorrenteAgrupada = await services.apiCall.requestApi(
                "/Fiscalizacao/GetContaCorrenteAgrupada",
                datax,
                "get"
            );
        
                var prodAcabado = 0;
                var indGranel = 0;
                var indEngarrafado = 0;

                for (let index = 0; index < ContaCorrenteAgrupada.length; index++) {
                    if(ContaCorrenteAgrupada[index].produtoAcabado != null && ContaCorrenteAgrupada[index].produtoAcabado != ""){
                        prodAcabado = parseFloat(ContaCorrenteAgrupada[index].produtoAcabado)
                    }
                    if(ContaCorrenteAgrupada[index].indisponivelGranel != null && ContaCorrenteAgrupada[index].indisponivelGranel != ""){
                        indGranel = parseFloat(ContaCorrenteAgrupada[index].indisponivelGranel)
                    }
                    if(ContaCorrenteAgrupada[index].indisponivelEngarrafado != null && ContaCorrenteAgrupada[index].indisponivelEngarrafado != ""){
                        indEngarrafado = parseFloat(ContaCorrenteAgrupada[index].indisponivelEngarrafado)
                    }
                }

                var IndispGranelQBD = indGranel;
                var IndispEngaQBD = indEngarrafado;
                var ProdutoAcabadoQBD = prodAcabado;
                var TotalQBD = indGranel + indEngarrafado + prodAcabado;

             
                arrayextra.push({
                    IndispGranelQBD: IndispGranelQBD,
                    IndispEngaQBD: IndispEngaQBD,
                    ProdutoAcabadoQBD: ProdutoAcabadoQBD,
                    TotalQBD: TotalQBD,
                })   
            
        })();
        if(arrayextra.length != 0){
            return  arrayextra
        }else{
            return false
        }
    };
    changeTotalQA = (Registo_DO) => {

        var resultIndispGranelQA = $('.IndispGranelQA').val() != '' ? parseFloat($('.IndispGranelQA').val()) : 0;

        var resultIndispEngaQA = $('.IndispEngaQA').val() != '' ? parseFloat($('.IndispEngaQA').val()) : 0;

        var resultProdutoAcabadoQA = $('.ProdutoAcabadoQA').val() != '' ? parseFloat($('.ProdutoAcabadoQA').val()) : 0;

        var resultVendasQA = $('.VendasQA').val() != '' ? parseFloat($('.VendasQA').val()) : 0;

        var result = resultIndispGranelQA + resultIndispEngaQA + resultProdutoAcabadoQA + resultVendasQA;

        this.state.data[this.state.data.findIndex(c=> c.Registo_DO.text == Registo_DO)].TotalQA = result;

        $('.TotalQA').text(result.toString())
        $('.TotalQA').val(result.toString())

    }


    changeTotalQT = (Registo_DO) => {

        var resultIndispGranelQT = $('.IndispGranelQT').val() != '' ? parseFloat($('.IndispGranelQT').val()) : 0;

        var resultIndispEngaQT = $('.IndispEngaQT').val() != '' ? parseFloat($('.IndispEngaQT').val()) : 0;

        var resultProdutoAcabadoQT = $('.ProdutoAcabadoQT').val() != '' ? parseFloat($('.ProdutoAcabadoQT').val()) : 0;

        var result = resultIndispGranelQT + resultIndispEngaQT + resultProdutoAcabadoQT;

        this.state.data[this.state.data.findIndex(c=> c.Registo_DO.text == Registo_DO)].TotalQT = result;

        $('.TotalQT').text(result.toString())
        $('.TotalQT').val(result.toString())

    }

     addNew = () => {

        
        if(!$('.botaoAdicionarNovoEnable').hasClass('disabled')){

            if($('#tabelaNovaAdicionar .k-grid-save-command').length == 0){

                const newDataItem = {
                            inEdit: true,
                            Discontinued: false,
                            NewItem :true,
                };
                if(this.state.data != undefined){
                    this.setState({
                        data: [newDataItem, ...this.state.data]
                       
                    });
                }else{
                    this.setState({
                        data: [newDataItem, ...arrayData]
                    });
                }
                

            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Não pode adicionar quando existe linhas em edição',
                }) 
            }
        }

    };

    refreshDS = (remove) =>{

        this.setState({
            data: []
        })
        arrayData = [];
        deleteAll();
    }

    SetColumnState = () =>{
        this.setState({
            Columns : this.props.columnList
          });
    }

    // static updateColumns = () =>{

    //     ThisSetState.setState({Columns : this.props.columnList});
    //     ThisSetState.refreshDS(true);

    // }

    render() {
        if(this.state.error){
            throw this.state.error;
        }        
    

        if(this.state.data != undefined){
            if(this.state.data.length > 0){
                
                arrayData = this.state.data
                
            }
        }     
        console.log(this.state.data + " TESTESTESTETSETSTESTESTETSETSTESTETSTETSTES");
        return (
            <div className="custom-k-grid table-section">
                <div className="table-responsive" id='tabelaNovaAdicionar'>

                    <Grid style={{height: "420px"}} data={arrayData.length > 0 ? arrayData : this.state.data } onItemChange={this.itemChange} editField={editField}>
                        <GridToolbar>
                            <button id='buttonclickAdicionar' title="Adicionar" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary botaoAdicionarNovoEnable disabled" onClick={this.addNew}>
                                + Adicionar
                            </button>
                        </GridToolbar>
                        {this.props.columnList}
                    </Grid>
                </div>
            </div>

        )
    }
}
const sendDataToClassGrid2 = (data) => {
    console.log("Dados recebidos em classGrid2.js:", data);
    if($("#tipo_auto :selected").val() == "4"){
        var RegistoSelecionado = data[0].Registo;
        setTimeout(() => {
            var botaoAdicionar = document.getElementById('buttonclickAdicionar');
            botaoAdicionar.click();
        }, 1000);
        setTimeout(() => {
            var dropdownElement = document.getElementById('id-DropDownCellCapacidades');
            var valorDesejado = RegistoSelecionado.text;
            dropdownElement.click();
            setTimeout(function() {
            var item = $(".k-list li").filter(function() {
                return $(this).text().trim() === valorDesejado;
            });
            
              if (item) {
                item.click();
              } else {
                console.log("Valor não encontrado nas opções.");
              }
            }, 1000); 
        }, 1000);
    }
};

export { sendDataToClassGrid2 , ClassGrid2 ,handleChange};

export const changeValueSelect2 = (e) => {

    SelectCellEtiquetas.changeValueFromSelect(e);
    SelectCellSelos.changeValueFromSelect(e);
    SelectCellEtiquetasSelagem.changeValueFromSelect(e);
    SelectCellSelosSelagem.changeValueFromSelect(e);
    SelectCellSelosGarantia.changeValueFromSelect(e);

}

export const changeColumnsFiscalizacaoGrid = (auto, typeAuto) => {

};

export default {ClassGrid2, DropDownCellFiscalizacao2, DropDownCellMotivoDispensa2};

